import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { IAddNewSiteActivePayload, IAddNewSiteResponse, IAddNewSiteUpcomingPayload } from '.';

export type AddNewSitePayload = IAddNewSiteUpcomingPayload | IAddNewSiteActivePayload;

interface IAddNewSiteType {
	mutate: UseMutateFunction<IAddNewSiteResponse, Error, AddNewSitePayload, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useAddEditNewSiteMutation = (siteId?: string | number): IAddNewSiteType => {
	const postData = async (formData: AddNewSitePayload): Promise<IAddNewSiteResponse> => {
		return await APIService.postData<IAddNewSiteResponse>(APICONFIG.LMS_SITE_ADD_OR_LIST_API, formData);
	};

	const putData = async (formData: AddNewSitePayload): Promise<IAddNewSiteResponse> => {
		return await APIService.putData<IAddNewSiteResponse>(`${APICONFIG.LMS_SITE_ADD_OR_LIST_API}${siteId}/`, formData);
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: siteId ? putData : postData,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
